/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Neat_Horse_LookInputs */

const en_free_neat_horse_look = /** @type {(inputs: Free_Neat_Horse_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start import`)
};

const de_free_neat_horse_look = /** @type {(inputs: Free_Neat_Horse_LookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import starten`)
};

/**
* | output |
* | --- |
* | "Start import" |
*
* @param {Free_Neat_Horse_LookInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const free_neat_horse_look = /** @type {((inputs?: Free_Neat_Horse_LookInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Neat_Horse_LookInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_neat_horse_look(inputs)
	return de_free_neat_horse_look(inputs)
});